/*
 * ATTENTION: An "eval-source-map" devtool has been used.
 * This devtool is neither made for production nor for readable output files.
 * It uses "eval()" calls to create a separate source file with attached SourceMaps in the browser devtools.
 * If you are trying to read the output file, select a different devtool (https://webpack.js.org/configuration/devtool/)
 * or disable the default devtool with "devtool: false".
 * If you are looking for production-ready output files, see mode: "production" (https://webpack.js.org/configuration/mode/).
 */
/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./src/styles/templates/collection.scss":
/*!**********************************************!*\
  !*** ./src/styles/templates/collection.scss ***!
  \**********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

eval("__webpack_require__.r(__webpack_exports__);\n// extracted by mini-css-extract-plugin\n//# sourceURL=[module]\n//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiLi9zcmMvc3R5bGVzL3RlbXBsYXRlcy9jb2xsZWN0aW9uLnNjc3MuanMiLCJtYXBwaW5ncyI6IjtBQUFBIiwic291cmNlcyI6WyJ3ZWJwYWNrOi8vYXhvbWUvLi9zcmMvc3R5bGVzL3RlbXBsYXRlcy9jb2xsZWN0aW9uLnNjc3M/YjU0NiJdLCJzb3VyY2VzQ29udGVudCI6WyIvLyBleHRyYWN0ZWQgYnkgbWluaS1jc3MtZXh0cmFjdC1wbHVnaW5cbmV4cG9ydCB7fTsiXSwibmFtZXMiOltdLCJzb3VyY2VSb290IjoiIn0=\n//# sourceURL=webpack-internal:///./src/styles/templates/collection.scss\n");

/***/ }),

/***/ "./src/js/templates/collection.js":
/*!****************************************!*\
  !*** ./src/js/templates/collection.js ***!
  \****************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

eval("__webpack_require__.r(__webpack_exports__);\n/* harmony import */ var Styles_templates_collection_scss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! Styles/templates/collection.scss */ \"./src/styles/templates/collection.scss\");\n\n\nif (document.querySelector('.template-collection') != null) {\n    let interval = setInterval(initInterval, 1000);\n\n    function initInterval() {\n        if (typeof (boostPFS) !== \"undefined\") {\n            setTimeout(function () {\n                document.querySelector('.CollectionInner__Products .ProductListWrapper.loading .ax-boost-loading').remove();\n                document.querySelector('.boost-pfs-filter-left-col').classList.remove('onload');\n                document.querySelector('.CollectionInner__Products .ProductListWrapper').classList.remove('loading');\n                stopInterval();\n            }, 200)\n        }\n    }\n\n    function stopInterval() {\n        clearInterval(interval);\n    }\n}//# sourceURL=[module]\n//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiLi9zcmMvanMvdGVtcGxhdGVzL2NvbGxlY3Rpb24uanMuanMiLCJtYXBwaW5ncyI6Ijs7QUFBQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBIiwic291cmNlcyI6WyJ3ZWJwYWNrOi8vYXhvbWUvLi9zcmMvanMvdGVtcGxhdGVzL2NvbGxlY3Rpb24uanM/OGI0MyJdLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgXCJTdHlsZXMvdGVtcGxhdGVzL2NvbGxlY3Rpb24uc2Nzc1wiO1xuXG5pZiAoZG9jdW1lbnQucXVlcnlTZWxlY3RvcignLnRlbXBsYXRlLWNvbGxlY3Rpb24nKSAhPSBudWxsKSB7XG4gICAgbGV0IGludGVydmFsID0gc2V0SW50ZXJ2YWwoaW5pdEludGVydmFsLCAxMDAwKTtcblxuICAgIGZ1bmN0aW9uIGluaXRJbnRlcnZhbCgpIHtcbiAgICAgICAgaWYgKHR5cGVvZiAoYm9vc3RQRlMpICE9PSBcInVuZGVmaW5lZFwiKSB7XG4gICAgICAgICAgICBzZXRUaW1lb3V0KGZ1bmN0aW9uICgpIHtcbiAgICAgICAgICAgICAgICBkb2N1bWVudC5xdWVyeVNlbGVjdG9yKCcuQ29sbGVjdGlvbklubmVyX19Qcm9kdWN0cyAuUHJvZHVjdExpc3RXcmFwcGVyLmxvYWRpbmcgLmF4LWJvb3N0LWxvYWRpbmcnKS5yZW1vdmUoKTtcbiAgICAgICAgICAgICAgICBkb2N1bWVudC5xdWVyeVNlbGVjdG9yKCcuYm9vc3QtcGZzLWZpbHRlci1sZWZ0LWNvbCcpLmNsYXNzTGlzdC5yZW1vdmUoJ29ubG9hZCcpO1xuICAgICAgICAgICAgICAgIGRvY3VtZW50LnF1ZXJ5U2VsZWN0b3IoJy5Db2xsZWN0aW9uSW5uZXJfX1Byb2R1Y3RzIC5Qcm9kdWN0TGlzdFdyYXBwZXInKS5jbGFzc0xpc3QucmVtb3ZlKCdsb2FkaW5nJyk7XG4gICAgICAgICAgICAgICAgc3RvcEludGVydmFsKCk7XG4gICAgICAgICAgICB9LCAyMDApXG4gICAgICAgIH1cbiAgICB9XG5cbiAgICBmdW5jdGlvbiBzdG9wSW50ZXJ2YWwoKSB7XG4gICAgICAgIGNsZWFySW50ZXJ2YWwoaW50ZXJ2YWwpO1xuICAgIH1cbn0iXSwibmFtZXMiOltdLCJzb3VyY2VSb290IjoiIn0=\n//# sourceURL=webpack-internal:///./src/js/templates/collection.js\n");

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module can't be inlined because the eval-source-map devtool is used.
/******/ 	var __webpack_exports__ = __webpack_require__("./src/js/templates/collection.js");
/******/ 	
/******/ })()
;